import { icon, inline, inlineAlignment as inlineAlignmentClass } from './icon.css';
import type { IconVariants } from './icon.css';
import type { IconName } from '@customerio/pluma-icons';
import type { color as colorStyle } from '@/css/typography.css';
import clsx from 'clsx';

export interface BaseIconProps {
	name: IconName;
	size?: IconVariants['size'];
	color?: keyof typeof colorStyle;
	label?: string;
	isInline?: boolean;
	inlineAlignment?: 'uppercase' | 'lowercase';
};

export function iconClassName(props: Partial<BaseIconProps>) {
	const { size, isInline, inlineAlignment } = props;

	let classes = [icon({size})];

	if (isInline) {
		classes.push(inline);

		if (inlineAlignment != null) {
			classes.push(inlineAlignmentClass[inlineAlignment]);
		} else {
			classes.push(inlineAlignmentClass['uppercase']);
		}
	}

	return clsx(classes);
}
